import React, { useState } from "react";
import Edit_Non_Work from "./edit_Complaints/Edit_Complaints";
import Non_Work_Form from "./complaints_Form/Complaints_Form";
import Non_Work_table from "./complaints_table/Complaints_table";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Edit_Complaints from "./edit_Complaints/Edit_Complaints";
import Complaints_Form from "./complaints_Form/Complaints_Form";
import Complaints_table from "./complaints_table/Complaints_table";

function Complaints() {
  const [isEdit, setIsEdit] = useState(false);

  return (
    <section className="Imperiality">
      {isEdit ? (
        <>
          <div className="back_div">
            <Common_Back_Btn backText="Edit Complaints" />
          </div>
          <Edit_Complaints onCancel={() => setIsEdit(false)} />
        </>
      ) : (
        <>
          <div className="back_div">
            <Common_Back_Btn backText="Complaints" />
          </div>

          <div className="imperiality_Form_div">
            <Complaints_Form/>
          </div>

          <div className="imperiality_table_div">
            <Complaints_table onEdit={() => setIsEdit(true)} />
          </div>
        </>
      )}
    </section>
  );
}

export default Complaints;
